module.exports = __webpack_public_path__ + "static/media/tick.fa60d76b.svg";